var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import clsx from 'clsx';
import { withForwardedRef } from '../utils/helpers/reactHelpers';
const BackDropSC = styled.div `
  z-index: ${(props) => props.theme.zIndex.topLayer - 1};
  position: fixed;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  background-color: ${(props) => props.theme.ColorBackgroundBackDrop};
  /* Remove grey highlight */
  -webkit-tap-highlight-color: transparent;
  /* Disable scroll capabilities.*/
  touch-action: none;

  &._ndsBackDrop--invisible {
    background: transparent;
  }
`;
const BackDrop = (props) => {
    const { forwardedRef, className: classNameProp, invisible, open } = props, others = __rest(props, ["forwardedRef", "className", "invisible", "open"]);
    return open ? (React.createElement(BackDropSC, Object.assign({ ref: forwardedRef, className: clsx(classNameProp, {
            '_ndsBackDrop--invisible': invisible
        }), "aria-hidden": true }, others))) : null;
};
BackDrop.propTypes = {
    forwardedRef: PropTypes.any,
    className: PropTypes.string,
    invisible: PropTypes.bool,
    open: PropTypes.bool.isRequired
};
BackDrop.defaultProps = {
    forwardedRef: React.createRef(),
    className: undefined,
    invisible: false
};
export default withForwardedRef(BackDrop);
//# sourceMappingURL=BackDrop.js.map